export default __webpack_public_path__ + "static/media/916.89781d72.png";